import Vue from 'vue';
import Vuex from 'vuex';

import dashboard from './dashboard';
import filters from './filters';
import modal from './modal';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        dashboard,
        filters,
        modal,
    },
    strict: process.env.NODE_ENV !== 'production',
});
